import { useRef, useState } from "react";

import icoArrow from '../Down_Arrow_3_.png'


function MenuNormal(props)
{

    const [visible, setVisible] = useState(0);


    const changeView = () => {
         if(visible == 0) setVisible(1);
         if(visible == 1) setVisible(0);
    }
     

    return <span className="gocenter td_btn_option">
                <div className="option_label link_color"  onClick={changeView} >opcje<img src={icoArrow}/></div>
                {
                    visible == 1  &&
                    <div className="quickMenu"  onClick={changeView} >                                                                       
                        {props.children}
                    </div>  
                }                
    </span>
}


export default MenuNormal;